// @ts-nocheck
import _ from "lodash";
import {
  ADD_CITY_TO_RATE_LIST_FAILURE,
  ADD_CITY_TO_RATE_LIST_REQUEST,
  ADD_CITY_TO_RATE_LIST_SUCCESS,
  CREATE_RATE_LIST_FAILURE,
  CREATE_RATE_LIST_REQUEST,
  CREATE_RATE_LIST_SUCCESS,
  DELETE_RATE_LIST_FAILURE,
  DELETE_RATE_LIST_POSITION_FAILURE,
  DELETE_RATE_LIST_POSITION_REQUEST,
  DELETE_RATE_LIST_POSITION_SUCCESS,
  DELETE_RATE_LIST_REQUEST,
  DELETE_RATE_LIST_SUCCESS,
  EDIT_RATE_LIST_FAILURE,
  EDIT_RATE_LIST_LOCALLY,
  EDIT_RATE_LIST_REQUEST,
  EDIT_RATE_LIST_SUCCESS,
  FETCH_CITY_LIST_FOR_CLIENT_FAILURE,
  FETCH_CITY_LIST_FOR_CLIENT_REQUEST,
  FETCH_CITY_LIST_FOR_CLIENT_SUCCESS,
  FETCH_MASTER_TIER_CITIES_FAILURE,
  FETCH_MASTER_TIER_CITIES_REQUEST,
  FETCH_MASTER_TIER_CITIES_SUCCESS,
  FETCH_RATE_CLIENT_LIST_FAILURE,
  FETCH_RATE_CLIENT_LIST_REQUEST,
  FETCH_RATE_CLIENT_LIST_SUCCESS,
  FETCH_RATE_LIST_FAILURE,
  FETCH_RATE_LIST_REQUEST,
  FETCH_RATE_LIST_SUCCESS,
  FETCH_SPECIFIC_RATE_LIST_FAILURE,
  FETCH_SPECIFIC_RATE_LIST_REQUEST,
  FETCH_SPECIFIC_RATE_LIST_SUCCESS,
  MANAGE_MASTER_TIER_CITIES_FAILURE,
  MANAGE_MASTER_TIER_CITIES_REQUEST,
  MANAGE_MASTER_TIER_CITIES_SUCCESS,
  REMOVE_CITY_FROM_RATE_LIST_FAILURE,
  REMOVE_CITY_FROM_RATE_LIST_REQUEST,
  REMOVE_CITY_FROM_RATE_LIST_SUCCESS,
  SAVE_RATE_LIST_FOR_EVENT_FAILURE,
  SAVE_RATE_LIST_FOR_EVENT_REQUEST,
  SAVE_RATE_LIST_FOR_EVENT_SUCCESS,
  SHARE_RATE_LIST_WITH_CLIENT_FAILURE,
  SHARE_RATE_LIST_WITH_CLIENT_REQUEST,
  SHARE_RATE_LIST_WITH_CLIENT_SUCCESS,
  TOGGLE_DEFAULT_RATE_FOR_CLIENT_FAILURE,
  TOGGLE_DEFAULT_RATE_FOR_CLIENT_REQUEST,
  TOGGLE_DEFAULT_RATE_FOR_CLIENT_SUCCESS,
  TOGGLE_RATE_LIST_FAILURE,
  TOGGLE_RATE_LIST_REQUEST,
  TOGGLE_RATE_LIST_SUCCESS,
  TOGGLE_INTEGRATION_RATES_FOR_CLIENT_FAILURE,
  TOGGLE_INTEGRATION_RATES_FOR_CLIENT_REQUEST,
  TOGGLE_INTEGRATION_RATES_FOR_CLIENT_SUCCESS,
  UPDATE_RATE_LIST_CONTENT_FAILURE,
  UPDATE_RATE_LIST_CONTENT_REQUEST,
  UPDATE_RATE_LIST_POSITION_DATA,
  UPDATE_TIER_CITY_SUCCESS,
  TOGGLE_INTEGRATION_SECTION,
  SHOW_TIER_RATE_LIST_REQUEST,
  SHOW_TIER_RATE_LIST_FAILURE,
  SHOW_TIER_RATE_LIST_SUCCESS,
  ADD_NEW_CITY_TO_RATE_LIST_REQUEST,
  ADD_NEW_CITY_TO_RATE_LIST_FAILURE,
  ADD_NEW_CITY_TO_RATE_LIST_SUCCESS,
} from "../../constants/config/rateList";

const initialState = {
  rateList: [],
  content: "",
  eventRateList: [],
  showIntegration: false,
  toggleIsDefaultRateLoader: false,
  toggleIntegrationRatesLoader: false,
  eventRateLoading: false,
  searchStaring: "",
  isLoading: false,
  deleteLoading: false,
  shareLoading: false,
  deleteId: null,
  totalPages: 0,
  currentPage: 1,

  // rate list inside event
  clientOptions: [],
  cityOptions: [],
  isLoadingClients: false,
  isLoadingCities: false,
  rateConfigLoading: false,
  tierVisibilityLoading: false,

  // tier cities
  tierCity: null,
  eventRateTierCity: null,
  tierLoading: false,
};

const rateListReducer = (state = initialState, action) => {
  switch (action?.type) {
    case FETCH_RATE_LIST_REQUEST:
      return {
        ...state,
        searchString: action?.payload,
        isLoading: true,
      };

    case FETCH_RATE_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case FETCH_RATE_LIST_SUCCESS:
      return {
        ...state,
        rateList: action?.payload?.data,
        isLoading: false,
        totalPages: action?.payload?.pagination?.totalPages,
        currentPage: action?.payload?.pagination?.currentPage,
      };

    // create rate list
    case CREATE_RATE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case CREATE_RATE_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case CREATE_RATE_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    // edit rate list request
    case EDIT_RATE_LIST_LOCALLY: {
      const newRateList = _.cloneDeep(state?.eventRateList);
      newRateList[action?.payload?.index]["rates"] = newRateList?.[
        action?.payload?.index
      ]?.rates?.map((i) => {
        if (i?._id == action?.payload?.data?.positionIds?.[0]?.id) {
          return { ...i, ...action?.payload?.data?.positionIds?.[0] };
        } else return i;
      });
      return {
        ...state,
        eventRateList: newRateList,
      };
    }

    // case EDIT_RATE_LIST_FAILURE:
    //   return state;
    //
    // case EDIT_RATE_LIST_SUCCESS:
    //   return state;

    // fetch specific rate list
    case FETCH_SPECIFIC_RATE_LIST_REQUEST:
      return {
        ...state,
        eventRateLoading: true,
      };

    case FETCH_SPECIFIC_RATE_LIST_FAILURE:
      return {
        ...state,
        eventRateLoading: false,
      };

    case FETCH_SPECIFIC_RATE_LIST_SUCCESS:
      return {
        ...state,
        eventRateLoading: false,
        eventRateList: action?.payload?.data || [],
        content: action?.payload?.data?.[0]?.comment,
        eventRateTierCity: action?.payload?.data?.[0]?.tiers,
      };

    // delete position from rate list
    case DELETE_RATE_LIST_POSITION_REQUEST:
      return {
        ...state,
        deleteId: action?.payload,
        deleteLoading: true,
      };

    case DELETE_RATE_LIST_POSITION_SUCCESS: {
      const newRateList = _.cloneDeep(state?.eventRateList);
      newRateList[action?.payload?.index]["rates"] = newRateList?.[
        action?.payload?.index
      ]?.rates?.map((i) => {
        if (i?._id == action?.payload?.data?._id) {
          return { ...i, ...action?.payload?.data };
        } else return i;
      });
      return {
        ...state,
        deleteLoading: false,
        eventRateList: newRateList,
      };
    }

    case DELETE_RATE_LIST_POSITION_FAILURE: {
      return {
        ...state,
        deleteLoading: false,
      };
    }

    // share rate list with client
    case SHARE_RATE_LIST_WITH_CLIENT_REQUEST:
      return {
        ...state,
        shareLoading: true,
      };

    case SHARE_RATE_LIST_WITH_CLIENT_FAILURE:
      return {
        ...state,
        shareLoading: false,
      };
    case SHARE_RATE_LIST_WITH_CLIENT_SUCCESS:
      return {
        ...state,
        shareLoading: false,
      };

    // add city to rate list
    case ADD_CITY_TO_RATE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        eventRateLoading: true,
      };
    case ADD_CITY_TO_RATE_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        eventRateLoading: false,
      };
    case ADD_CITY_TO_RATE_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        eventRateLoading: false,
      };

    // add new city to rate list
    case ADD_NEW_CITY_TO_RATE_LIST_REQUEST:
      return {
        ...state,
        tierLoading: true,
      };
    case ADD_NEW_CITY_TO_RATE_LIST_FAILURE:
      return {
        ...state,
        tierLoading: false,
      };
    case ADD_NEW_CITY_TO_RATE_LIST_SUCCESS:
      return {
        ...state,
        tierLoading: false,
        eventRateList: state?.eventRateList?.map((r) => ({
          ...r,
          tiers: action?.payload,
        })),
        eventRateTierCity: action?.payload,
      };

    // remove city from rate list
    case REMOVE_CITY_FROM_RATE_LIST_REQUEST:
      return {
        ...state,
        tierLoading: true,
      };
    case REMOVE_CITY_FROM_RATE_LIST_FAILURE:
      return {
        ...state,
        tierLoading: false,
      };
    case REMOVE_CITY_FROM_RATE_LIST_SUCCESS:
      return {
        ...state,
        tierLoading: false,
        eventRateList: state?.eventRateList?.map((r) => ({
          ...r,
          tiers: action?.payload,
        })),
        eventRateTierCity: action?.payload,
      };

    // delete rate list
    case DELETE_RATE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case DELETE_RATE_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case DELETE_RATE_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    // rate list comment
    case UPDATE_RATE_LIST_CONTENT_REQUEST:
      return {
        ...state,
        content: action?.payload,
      };

    // rate list options
    case FETCH_RATE_CLIENT_LIST_REQUEST:
      return {
        ...state,
        isLoadingClients: true,
      };

    case FETCH_RATE_CLIENT_LIST_SUCCESS:
      return {
        ...state,
        clientOptions: action?.payload,
        isLoadingClients: false,
      };

    case FETCH_RATE_CLIENT_LIST_FAILURE:
      return {
        ...state,
        isLoadingClients: false,
      };

    // fetch city rate list
    case FETCH_CITY_LIST_FOR_CLIENT_REQUEST:
      return {
        ...state,
        isLoadingCities: true,
      };

    case FETCH_CITY_LIST_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        cityOptions:
          action?.payload?.length == 0 ? state?.cityOptions : action?.payload,
        isLoadingCities: false,
      };

    case FETCH_CITY_LIST_FOR_CLIENT_FAILURE:
      return {
        ...state,
        isLoadingCities: false,
      };

    // save rate list event
    case SAVE_RATE_LIST_FOR_EVENT_REQUEST:
      return {
        ...state,
        rateConfigLoading: true,
      };
    case SAVE_RATE_LIST_FOR_EVENT_SUCCESS:
      return {
        ...state,
        rateConfigLoading: false,
      };
    case SAVE_RATE_LIST_FOR_EVENT_FAILURE:
      return {
        ...state,
        rateConfigLoading: false,
      };

    // update rate list's position data
    case UPDATE_RATE_LIST_POSITION_DATA: {
      const updatedEventRateList = state?.eventRateList?.map((category) => {
        if (category?._id == action?.payload?.rateListId) {
          return {
            ...category,
            rates: category?.rates?.map((rates) => {
              if (rates?.positionId == action?.payload?.newData?._id) {
                const newData = action?.payload?.newData;
                return {
                  ...rates,
                  positionName: newData?.positionName,
                  abbreviation: newData?.abbreviation,
                  equipmentRequired: newData?.equipmentRequired,
                  positionBrief: newData?.positionBrief,
                  tag: newData?.tag,
                  positionDescription: newData?.positionDescription,
                  isFullDay: newData?.isFullDay,
                  orderInRateSheet: newData?.orderInRateSheet,
                };
              } else {
                return rates;
              }
            }),
          };
        } else {
          return category;
        }
      });
      return {
        ...state,
        eventRateList: updatedEventRateList,
      };
    }

    // toggle rate list
    case TOGGLE_RATE_LIST_REQUEST:
      return {
        ...state,
      };

    case TOGGLE_RATE_LIST_FAILURE:
      return {
        ...state,
      };

    case TOGGLE_RATE_LIST_SUCCESS: {
      const oldValue = state?.eventRateList?.[0]?.isActive;
      const newEventRateList = state?.eventRateList?.map((r) => ({
        ...r,
        isActive: !oldValue,
      }));

      return {
        ...state,
        eventRateList: newEventRateList,
      };
    }

    // fetch master tier cities
    case FETCH_MASTER_TIER_CITIES_REQUEST:
      return {
        ...state,
        tierLoading: true,
      };

    case FETCH_MASTER_TIER_CITIES_FAILURE:
      return {
        ...state,
        tierLoading: false,
      };

    case FETCH_MASTER_TIER_CITIES_SUCCESS:
      return {
        ...state,
        tierLoading: false,
        tierCity: action?.payload?.tiers,
      };

    // manage tier cities
    case MANAGE_MASTER_TIER_CITIES_REQUEST:
      return {
        ...state,
        tierLoading: true,
      };

    case MANAGE_MASTER_TIER_CITIES_FAILURE:
      return {
        ...state,
        tierLoading: false,
      };

    case MANAGE_MASTER_TIER_CITIES_SUCCESS:
      return {
        ...state,
        tierLoading: false,
        tierCity: action?.payload?.tiers,
      };

    // update rate list
    case UPDATE_TIER_CITY_SUCCESS:
      return {
        ...state,
        eventRateTierCity: action?.payload?.tiers,
      };

    // toggle client default rate for client
    case TOGGLE_DEFAULT_RATE_FOR_CLIENT_REQUEST:
      return {
        ...state,
        toggleIsDefaultRateLoader: true,
      };
    case TOGGLE_DEFAULT_RATE_FOR_CLIENT_SUCCESS: {
      const currentValue =
        state?.eventRateList?.[0]?.isDefaultRateVisibleToClient;
      const updatedEventRateList = state?.eventRateList?.map((r) => ({
        ...r,
        isDefaultRateVisibleToClient: !currentValue,
      }));
      return {
        ...state,
        toggleIsDefaultRateLoader: false,
        eventRateList: updatedEventRateList,
      };
    }
    case TOGGLE_DEFAULT_RATE_FOR_CLIENT_FAILURE:
      return {
        ...state,
        toggleIsDefaultRateLoader: false,
      };

    // toggle integration rates for client
    case TOGGLE_INTEGRATION_RATES_FOR_CLIENT_REQUEST:
      return {
        ...state,
        toggleIntegrationRatesLoader: true,
      };
    case TOGGLE_INTEGRATION_RATES_FOR_CLIENT_SUCCESS: {
      const currentValue = state?.eventRateList?.[0]?.includeIntegrationRate;
      const updatedEventRateList = state?.eventRateList?.map((r) => ({
        ...r,
        includeIntegrationRate: !currentValue,
      }));
      return {
        ...state,
        toggleIntegrationRatesLoader: false,
        eventRateList: updatedEventRateList,
      };
    }
    case TOGGLE_INTEGRATION_RATES_FOR_CLIENT_FAILURE:
      return {
        ...state,
        toggleIntegrationRatesLoader: false,
      };

    // toggle integration section
    case TOGGLE_INTEGRATION_SECTION:
      return {
        ...state,
        showIntegration: !state?.showIntegration,
      };

    //  show tier options
    case SHOW_TIER_RATE_LIST_REQUEST:
      return {
        ...state,
        tierVisibilityLoading: true,
      };

    case SHOW_TIER_RATE_LIST_FAILURE:
      return {
        ...state,
        tierVisibilityLoading: false,
      };

    case SHOW_TIER_RATE_LIST_SUCCESS: {
      const newEventRateSheet = state?.eventRateList?.map((r) => ({
        ...r,
        isTier1Visible: action?.payload?.isTier1Visible,
        isTier2Visible: action?.payload?.isTier2Visible,
        isTier3Visible: action?.payload?.isTier3Visible,
        isPremiumTierVisible: action?.payload?.isPremiumTierVisible,
        isBudgetTierVisible: action?.payload?.isBudgetTierVisible,
      }));
      return {
        ...state,
        tierVisibilityLoading: false,
        eventRateList: newEventRateSheet,
      };
    }

    default:
      return state;
  }
};

export default rateListReducer;
export { initialState };